// React
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

// Ionic
import {
  IonContent,
  IonPage,
  IonGrid,
  IonRow,
  IonCol,
  IonButtons,
  IonIcon,
  IonCard,
  IonButton,
  IonCardContent,
  IonModal,
} from "@ionic/react";
import {
  shareSocialSharp,
  call,
  mailOutline,
  desktopOutline,
  logoFacebook,
  logoPinterest,
  logoTwitter,
  closeOutline,
  bookmark as bookmarkicon,
  bookmarkOutline,
  compassOutline,
} from "ionicons/icons";

// Components
import Map from "../components/Map/Map";
import Marker from "../components/Map/Marker";
import Tab from "../components/SinglePitch/Tab";
import TabEntsorgung from "../components/SinglePitch/TabEntsorgung";

//Data
import UserService from "../Context/user.service";

// Packages
import { Wrapper } from "@googlemaps/react-wrapper";
import ModalBookmark from "../Context/bookmark.modal";

const render = (status) => {
  return <h1>{status}</h1>;
};

var userInitial = 0;
var logedInInitial = false;
var isProinitial = false;
var tokenInitial = "";

const tokenData = UserService.getUserData();

if (typeof tokenData["tokenData"].MerchantCustomerId !== "undefined") {
  userInitial = tokenData["tokenData"].MerchantCustomerId;
  logedInInitial = true;

  if (tokenData.login == 1) {
    logedInInitial = true;
  }
  if (tokenData.pro == 1) {
    isProinitial = true;
  }

  tokenInitial = tokenData.cookie;
}

function SinglePitch(props) {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  // Touren Item Values
  const [hasTourenData, setHasTourenData] = useState(false);
  const [tourenName, setTourenName] = useState("Keine Route vorhanden");
  const [tourenExcerpt, setTourenExcerpt] = useState("");
  const [tourenLink, setTourenLink] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(logedInInitial);
  const [user, setUser] = useState(userInitial);
  const [token, setToken] = useState(tokenInitial);
  const [isPro, setIsPro] = useState(isProinitial);
  const [tourenImageUrl, setTourenImageUrl] = useState("");
  const [usedVouchers, setUsedVouchers] = useState([]);
  //News Item Values
  const [hasNewsData, setHasNewsData] = useState(false);
  const [newsName, setNewsName] = useState("Keine News vorhanden");
  const [newsExcerpt, setNewsExcerpt] = useState("");
  const [newsLink, setNewsLink] = useState("");
  const [newsImageUrl, setNewsImageUrl] = useState("");

   //News Item Values
   const [hasSpecialsData, setHasSpecialsData] = useState(false);
   const [specialsName, setSpecialsName] = useState("Keine Specials vorhanden");
   const [specialsExcerpt, setSpecialsExcerpt] = useState("");
   const [specialsLink, setSpecialsLink] = useState("");
   const [specialsImageUrl, setSpecialsImageUrl] = useState("");

  //Check Evaluation
  const [markers, setMarkers] = useState([]);
  const [zoom, setZoom] = useState(12); // initial zoom
  const [center, setCenter] = useState();

  const [bookmark, setbookmark] = useState([]);
  const [allbookmarks, setAllBookmarks] = useState([]);

  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [navigationModalOpen, setNavigationModalOpen] = useState(false);
  const [modalText, setModalText] = useState("");

  const pid = user;
  const { id } = useParams();


  function showModal(id) {
    window.openid = id;
    document.getElementById("openmodal").click();
  }

  //Maps
  const onClick = (e) => {
    // avoid directly mutating state
    setMarkers([...markers, e.latLng]);
  };

  const onIdle = (m) => {
    setZoom(m.getZoom());
    setCenter(m.getCenter().toJSON());
  };

  //Date Format
  let currentDate = new Date().getFullYear();
  function changeDateFormat(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [day, month, year].join(".");
  }

  // Share on Facebook
  function shareFacebook(e) {
    e.preventDefault();

    var currentUrl = document.URL;

    if (typeof window.parent.document.URL !== "undefined") {
      currentUrl = window.parent.document.URL;
    }

    var facebookWindow = window.open(
      "https://www.facebook.com/sharer/sharer.php?u=" + currentUrl,
      "facebook-popup"
    );
    if (facebookWindow.focus) {
      facebookWindow.focus();
    }
    return false;
  }

  function sharePinterest(e) {
    e.preventDefault();

    var currentUrl = document.URL;
    var pinterestWindow = window.open(
      "https://pinterest.com/pin/create/link/?url=" + currentUrl,
      "pinterest-popup"
    );

    if (pinterestWindow.focus) {
      pinterestWindow.focus();
    }

    return false;
  }

  function shareTwitter(e) {
    e.preventDefault();

    var currentUrl = encodeURIComponent(document.URL);
    var twitterWindow = window.open(
      "https://twitter.com/share?url=" + currentUrl,
      "twitter-popup"
    );

    if (twitterWindow.focus) {
      twitterWindow.focus();
    }

    return false;
  }

  // Share Link
  function sharePage(e) {
    setShareModalOpen(true);
    // Get the current page URL
    var currentUrl = document.URL;

    if (typeof window.parent.document.URL !== "undefined") {
      currentUrl = window.parent.document.URL;
    }

    // Copy the current page URL to the clipboard
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        setModalText(`Die URL wurde erfolgreich kopiert: ${currentUrl}`);
      })
      .catch(() => {
        setModalText(
          `Es ist etwas schief gelaufen. Bitte versuche es später noch einmal.`
        );
      });
  }

  function shareMobile(e) {
    e.preventDefault();

    // Check if the share API is supported by the browser
    if (navigator.share) {
      // Get the current page URL
      var currentUrl = document.URL;

      if (typeof window.parent.document.URL !== "undefined") {
        currentUrl = window.parent.document.URL;
      }

      // Use the share API to share the current page URL
      navigator.share({
        title: document.title,
        url: currentUrl,
      });
    } else {
      alert("Die Teilen-Funktion wird von deinem Browser nicht unterstützt.");
    }
  }

  function closeModalShare() {
    setShareModalOpen(false);
  }
  function openModalShare() {
    setShareModalOpen(true);
  }
  function closeModalNavigation() {
    setNavigationModalOpen(false);
  }
  function openModalNavigation() {
    setNavigationModalOpen(true);
  }
  function onWillDismiss() {
    setShareModalOpen(false);
    setNavigationModalOpen(false);
  }

  //Send Pitch Name for "Stellplatz melden"
  function sendPitchName() {}

  function howtogetpro() {
    if (typeof window.parent.setPaywallModal !== "undefined") {
      window.parent.setPaywallModal("pro");
    }
  }

  //GetDATA
  useEffect(() => {
    UserService.getBookmarks(pid, token).then(
      (response) => {
        setbookmark(response.data);

        var allb = [];
        response.data.lists.forEach((list) => {
          list.items.forEach((item) => {
            if (typeof item === "number") {
              allb.push(item);
            }
          });
        });

        setAllBookmarks(allb);
      },
      (error) => {
        setError(error);
      }
    );

    UserService.getDetailFields(parseInt(id)).then(
      (response) => {
        var item = response.data;

        if (
          typeof item.evaluation.checks !== "undefined" &&
          typeof item.evaluation.checks.check === "string"
        ) {
          var check = {
            text: item.evaluation.checks.check,
            icon: item.evaluation.checks.checkIcon,
          };
          item.evaluation.checks.check = [check];
        }

        setItems(item);

        setCenter({
          lat: parseFloat(item.gps.latitude),
          lng: parseFloat(item.gps.longitude),
        });

        if (isLoggedIn) {
          UserService.getUsedVouchers(user, token).then((response) => {
            if (
              typeof response.data !== "undefined" &&
              typeof response.data.vouchers !== "undefined"
            ) {
              setUsedVouchers(response.data.vouchers);
            }
            setIsLoaded(true);
          });
        } else {
          setIsLoaded(true);
        }
      },
      (error) => {
        setError(error);
      }
    );

    UserService.getTourenArray().then(
      (response) => {
        var tourenArray = response.data;
        var searchVal = parseInt(id);

        for (var i = 0; i < tourenArray.length; i++) {

          if (tourenArray[i].acf.ids.search(searchVal) >= 0) {
            setTourenName(tourenArray[i].title.rendered);
            setTourenExcerpt(tourenArray[i].excerpt.rendered);
            setTourenImageUrl(
              tourenArray[i]._embedded["wp:featuredmedia"][0].source_url
            );
            setTourenLink(tourenArray[i].link);
            setHasTourenData(true);
            break;
          }
        }
      },
      (error) => {
        setError(error);
      }
    );

    UserService.getNewsArray().then(
      (response) => {
        var newsArray = response.data;
        var searchVal = parseInt(id);

        for (var i = 0; i < newsArray.length; i++) {
          if (newsArray[i].acf.ids.search(searchVal) >= 0) {
            setNewsName(newsArray[i].title.rendered);
            setNewsExcerpt(newsArray[i].excerpt.rendered);
            setNewsImageUrl(
              newsArray[i]._embedded["wp:featuredmedia"][0].source_url
            );
            setNewsLink(newsArray[i].link);
            setHasNewsData(true);
            break;
          }
        }
      },
      (error) => {
        setError(error);
      }
    );
    UserService.getSpecialsArray().then(
      (response) => {
        var specialsArray = response.data;
        var searchVal = parseInt(id);

  
        for (var i = 0; i < specialsArray.length; i++) {
          if (specialsArray[i].acf.ids.search(searchVal) >= 0) {
            setSpecialsName(specialsArray[i].title.rendered);
            setSpecialsExcerpt(specialsArray[i].excerpt.rendered);
            setSpecialsImageUrl(
              specialsArray[i]._embedded["wp:featuredmedia"][0].source_url
            );
            setSpecialsLink(specialsArray[i].link);
            setHasSpecialsData(true);
            break;
          }
        }
      } ,
      (error) => {
        setError(error);
      }
    );
  }, []);

  var fav = false;
  if (allbookmarks.indexOf(items.id) !== -1) {
    fav = true;
  }
  
  console.log(items);

  if (
    typeof window.parent.seturl !== "undefined" &&
    typeof items !== "undefined" &&
    typeof items.id !== "undefined"
  ) {
    window.parent.seturl("pitch", items.slug);
    //window.parent.seturl("pitch", items.id);
  }

  function frameEscapeProtection(slug){
    const mainUrl = '/stellplatz/'+slug;
    if(window.location.href==window.parent.location.href){
        window.location.href = mainUrl;
    }
  }

  function decode(str) {
    let txt = document.createElement("div");
    txt.innerHTML = str;
    var realtext = txt.innerText.replaceAll("&nbsp;", "\u00A0");
    return realtext;
  }

  

  return isLoaded ? (
    <IonPage>
      {frameEscapeProtection(items.slug)}
      <ModalBookmark
        isLoggedInValue={isLoggedIn}
        isProValue={isPro}
        pid={pid}
        bookmark={bookmark}
        setbookmark={setbookmark}
        token={token}
      />
      <IonModal
        isOpen={shareModalOpen}
        id="sharemodal"
        onWillDismiss={() => onWillDismiss()}
      >
        {" "}
        <IonRow className="ion-align-items-center ion-text-center sharemodal__text ">
          {" "}
          <p className="p__big">{modalText}</p>
        </IonRow>
        <IonButtons slot="end" className="sharemodal__button">
        <IonButton onClick={() => closeModalShare()}><IonIcon
            icon={closeOutline}
            
          /></IonButton>
          
        </IonButtons>
      </IonModal>

      <IonModal
        isOpen={navigationModalOpen}
        id="navigationmodal"
        onWillDismiss={() => onWillDismiss()}
      >
        <IonRow className="">
          <IonCol size="12">
            {" "}
            <a
              href={`https://www.google.com/maps/search/${items.street}+${items.postcode}+${items.city}`}
              target="_blank"
            >
              <IonButton color="primary" shape="round" expand="full">
                Google Maps
              </IonButton>
            </a>
          </IonCol>
          <IonCol size="12">
            {" "}
            <a
              href={`maps://?daddr=${items.gps.latitude},${items.gps.longitude}&amp;navigate=yes`}
              target="_blank"
            >
              <IonButton color="primary" shape="round" expand="full">
                Apple Maps
              </IonButton>
            </a>
          </IonCol>
          <IonCol size="12">
            {" "}
            <a
              href={`tomtomgo://x-callback-url/navigate?destination=${items.gps.latitude},${items.gps.longitude}&amp;name=${items.stellplatzname}`}
              target="_blank"
            >
              <IonButton color="primary" shape="round" expand="full">
                TomTom
              </IonButton>
            </a>
          </IonCol>
          <IonCol size="12">
            {" "}
            <IonButton
              color="secondary"
              shape="round"
              expand="full"
              onClick={() => closeModalNavigation()}
            >
              Navigation schließen
            </IonButton>
          </IonCol>
        </IonRow>
      </IonModal>

      <IonContent fullscreen>
        <Wrapper
          apiKey={"AIzaSyA_F83EK6cz_LUYSGUSCdcmLDZja7Dk0ho"}
          render={render}
        >
          <Map
            center={center}
            onClick={onClick}
            onIdle={onIdle}
            zoom={zoom}
            style={{ flexGrow: "1", height: "40%" }}
          >
            <Marker
              position={{
                lat: parseFloat(items.gps.latitude),
                lng: parseFloat(items.gps.longitude),
              }}
              id={items.id}
              marker={items.stellplatztyp}
            />
          </Map>
        </Wrapper>
        <IonGrid className="content__margin">
          <IonRow>
            <IonCol size="10" size-md="9" size-xl="9">
              <h6>{decode(items.stellplatztyp)}</h6>
              <h2>{decode(items.stellplatzname)}</h2>
              <p>
                {decode(items.street)}, {items.postcode} {decode(items.city)},{" "}
                {decode(items.countryName)}
              </p>
            </IonCol>
            <IonCol
              size="2"
              size-md="3"
              size-xl="3"
              className="ion-text-end"
              data-fav={fav}
              data-icon-id={items.id}
            >
              <p className="share__text">
                {" "}
                <span className="bookmark__text ion-hide-md-down">
                  Auf die Merkliste
                </span>
                <p className="bookmark__icon">
                  {" "}
                  <a onClick={() => showModal(items.id)}>
                    <IonIcon
                      className="bookmark_inactive"
                      size="lg"
                      icon={bookmarkOutline}
                      color="light"
                    />
                  </a>{" "}
                  <a onClick={() => showModal(items.id)}>
                    <IonIcon
                      className="bookmark_active"
                      size="lg"
                      icon={bookmarkicon}
                      color="light"
                    />
                  </a>
                </p>
              </p>
              <br />
              <p className="share__text">
                <span className="ion-hide-md-down">Teilen</span>
                <a
                  onClick={shareFacebook}
                  className="share__icon ion-hide-md-down"
                >
                  {" "}
                  <IonIcon icon={logoFacebook}></IonIcon>
                </a>
                <a
                  onClick={sharePinterest}
                  className="share__icon ion-hide-md-down"
                >
                  {" "}
                  <IonIcon icon={logoPinterest}></IonIcon>
                </a>
                <a
                  onClick={shareTwitter}
                  className="share__icon ion-hide-md-down"
                >
                  {" "}
                  <IonIcon icon={logoTwitter}></IonIcon>
                </a>
                <a onClick={sharePage} className="share__icon ion-hide-md-down">
                  <IonIcon icon={shareSocialSharp}></IonIcon>
                </a>
                <a
                  onClick={shareMobile}
                  className="share__icon ion-hide-md-up "
                >
                  <IonIcon icon={shareSocialSharp}></IonIcon>
                </a>
              </p>
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonGrid className="content__margin">
          <IonRow>
            <IonCol size="12" size-lg="8" size-xl="8">
              {items.stellplatztyp === "Stellplatz" ||
              items.stellplatztyp === "Stellplatz mit Entsorgungsstation" ? (
                <Tab
                  name={items.stellplatzname}
                  postcode={items.postcode}
                  city={items.city}
                  url={items.mainimage}
                  caravanAvailable={items.place.gespanneErlaubt}
                  anzahlStellplaetze={items.place.numberOfPitches}
                  anzahlCaravans={items.place.numberOfCaravans}
                  stellplaetzeLaenge={items.place.maxLengthOfPitches}
                  caravanLaenge={items.place.maxLengthOfCaravans}
                  untergrund={items.place.undergrounds.underground}
                  premiumValue={items.premium}
                  premiumText={items.premiumeintrag}
                  umweltzone={items.umweltzone}
                  vergleichspreis={items.prices}
                  labelpreis={items.prices.generalPrice}
                  platzbeschreibung={items.place.description}
                  oeffnungszeiten={items.openingTimes}
                  anfahrt={items.anfahrt}
                  ausgewiesenValue={items.place.stellplaetzeAusgewiesen.wert}
                  reservierung={items.reservation}
                  aufenthalt={items.conditions}
                  entfernungen={items.entfernungenTags}
                  gastronomie={items.gastro}
                  ausstattung={items.features.feature}
                  images={items.images.image}
                  prices={items.prices.extra}
                  freizeitangebote={items.activities}
                  sehenswuerdigkeiten={items.pois}
                  voucher={items.vouchers.voucher}
                  fav={fav}
                  email={items.contacts.email}
                  entsorgungsstation={items.entsorgungsstation}
                  stellplatztyp={items.stellplatztyp}
                  category={items.category}
                />
              ) : (
                <>
                  <TabEntsorgung
                    url={items.mainimage}
                    entsorgungsstation={items.entsorgungsstation}
                  ></TabEntsorgung>
                </>
              )}
            </IonCol>
            <IonCol size="12" size-lg="4" size-xl="4">
              {currentDate - items.evaluation.year <= 2 &&
              (items.evaluation.length !== 0 ||
                items.evaluation.date !== undefined) &&
              items.evaluation.correspondent !== undefined ? (
                <IonCard className="ion-margin-bottom">
                  <IonCardContent>
                    <IonRow>
                      <IonCol
                        size="12"
                        size-sm="3"
                        className="align_center justify_center"
                      >
                        {items.evaluation.id_correspondent !== "" ? (
                          <>
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                `/assets/correspondent/${items.evaluation.id_correspondent}.png`
                              }
                              alt="Stellplatzkorrespondent"
                              className="image__correspondent"
                            />
                          </>
                        ) : (
                          <>
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                `/assets/correspondent/placeholder.png`
                              }
                              alt="Stellplatzkorrespondent"
                              className="image__correspondent"
                            />
                          </>
                        )}
                      </IonCol>
                      <IonCol size="12" size-sm="7" className="justify_center">
                        <h6>
                          Stellplatz-
                          <br />
                          korrespondent/in
                        </h6>

                        <p className="p__big">
                          {" "}
                          <b>{items.evaluation.correspondent}</b>
                        </p>

                        <p>
                          hat diesen Stellplatz am{" "}
                          {changeDateFormat(items.evaluation.date)} geprüft.{" "}
                        </p>
                      </IonCol>
                      <IonCol
                        size="12"
                        size-sm="2"
                        className="align_center justify_center"
                      >
                        <img
                          src={items.evaluation.imagepath}
                          alt="Prüfsiegel"
                        />
                      </IonCol>
                      <IonCol size="12">
                        <hr className="hr_white" />
                        {typeof items.evaluation.checks.check !== "undefined" &&
                          items.evaluation.checks.check.map((item) => {
                            return (
                              <table className="table table-hover table-striped">
                                <tr className="tr__xs">
                                  <td className="font__icon ">{item.icon}</td>
                                </tr>
                                <tr className="tr__xl">
                                  <td>{item.text}</td>
                                </tr>
                              </table>
                            );
                          })}
                      </IonCol>
                    </IonRow>
                  </IonCardContent>
                </IonCard>
              ) : (
                <></>
              )}

              <IonCard className="ion-margin-bottom">
                <IonCardContent>
                  <IonRow>
                    <IonCol size="12">
                      <h6>Adresse / Kontakt</h6>
                    </IonCol>
                  </IonRow>
                  <IonRow>
                    <IonCol size="12">
                      <p className="reduced__lineheight">
                        {decode(items.stellplatzname)}
                        <br />
                        {decode(items.street)}
                        <br />
                        {items.postcode} {decode(items.city)}
                        <br />
                        {decode(items.countryName)}
                      </p>
                      <br />
                      <p className="reduced__lineheight">
                        GPS: <br />
                        {items.gps.latitude}, {items.gps.longitude}
                        <br />
                        {items.gpsstring}
                      </p>
                    </IonCol>
                  </IonRow>
                  <hr className="hr_white" />

                  <IonRow>
                    <IonCol size="12">
                      {typeof items.contacts.phone !== "undefined" && items.contacts.phone.length !== 0 && (
                        <>
                          <table className="table table-hover table-striped">
                            <tr className="tr__xs">
                              <td className="font__icon ">
                                <IonIcon icon={call}></IonIcon>
                              </td>
                            </tr>
                            <tr className="tr__xl">
                              <td>
                                <a href={`tel:${items.contacts.phone}`}>
                                  {items.contacts.phone}
                                </a>
                              </td>
                            </tr>
                          </table>
                        </>
                      )}
                    </IonCol>
                    <IonCol size="12">
                      {typeof items.contacts.website !== "undefined" && items.contacts.website.length !== 0 && (
                        <p>
                          <table className="table table-hover table-striped">
                            <tr className="tr__xs">
                              <td className="font__icon ">
                                <IonIcon icon={desktopOutline}></IonIcon>
                              </td>
                            </tr>
                            <tr className="tr__l">
                              <td>
                                <a href={items.contacts.website} target='_blank' rel="noreferrer" >
                                  {items.contacts.website
                                    .replaceAll("https://", "")
                                    .replaceAll("http://", "")}
                                </a>
                              </td>
                            </tr>
                          </table>
                        </p>
                      )}
                    </IonCol>

                    {(function () {
                      if (isPro) {
                        return (
                          <>
                            <IonCol
                              size="12"
                              size-lg="12"
                              size-xl="6"
                              className="ion-text-start"
                            >
                              <IonButton
                                color="primary"
                                shape="round"
                                onClick={openModalNavigation}
                              >
                                Navigation
                                <IonIcon
                                  icon={compassOutline}
                                  className="icon_request"
                                ></IonIcon>
                              </IonButton>
                            </IonCol>
                            <IonCol
                              size="12"
                              size-lg="12"
                              size-xl="6"
                              className="ion-text-end-mobile"
                            >
                              {typeof items.contacts.email !== "undefined" && items.contacts.email.length !== 0 && (
                                <p>
                                  <a
                                    href={`${window.config.wppath}/anfrage-an-stellplatz/?emailto=${items.contacts.email}?title=${items.stellplatzname}`}
                                    className="text_request"
                                    target="_blank"
                                  >
                                    <IonButton color="primary" shape="round">
                                      Anfrage
                                      <IonIcon
                                        icon={mailOutline}
                                        className="icon_request"
                                      ></IonIcon>
                                    </IonButton>
                                  </a>
                                </p>
                              )}
                            </IonCol>
                          </>
                        );
                      } else {
                        return (
                          <>
                            <IonCol
                              size="12"
                              size-lg="12"
                              size-xl="6"
                              className="ion-text-start"
                            >
                              <IonButton
                                color="primary"
                                shape="round"
                                onClick={(e) => howtogetpro()}
                              >
                                Navigation
                                <IonIcon
                                  icon={compassOutline}
                                  className="icon_request"
                                ></IonIcon>
                              </IonButton>
                            </IonCol>
                            <IonCol
                              size="12"
                              size-lg="12"
                              size-xl="6"
                              className="ion-text-end-mobile"
                            >
                              {typeof items.contacts.email !== "undefined" && items.contacts.email.length !== 0 && (
                                <p>
                                  <IonButton
                                    color="primary"
                                    shape="round"
                                    onClick={(e) => howtogetpro()}
                                  >
                                    Anfrage
                                    <IonIcon
                                      icon={mailOutline}
                                      className="icon_request"
                                    ></IonIcon>
                                  </IonButton>
                                </p>
                              )}
                            </IonCol>
                          </>
                        );
                      }
                    })()}
                  </IonRow>
                </IonCardContent>
              </IonCard>
              <IonCard>
                <IonCardContent>
                  <IonRow>
                    <IonCol size="12">
                      <h6>Stellplatz melden</h6>
                    </IonCol>
                  </IonRow>
                  <IonRow>
                    <IonCol size="12">
                      <p>
                        Haben sich Preise oder Service-Leistungen geändert?{" "}
                        <br />
                        Dann teilen Sie uns diese gern mit.{" "}
                      </p>
                    </IonCol>
                    <IonCol size="12" className="ion-text-end">
                      <a
                        href={`${window.config.wppath}/stellplatz-aendern?title=${items.stellplatzname}?id=${items.id}`}
                        target="_blank"
                      >
                        {" "}
                        <IonButton
                          color="primary"
                          shape="round"
                          size="small"
                          expand="full"
                          className="ion-hide-xl-up button__maxwidth"
                        >
                          <span> Stellplatzdaten korrigieren</span>
                        </IonButton>
                        <IonButton
                          color="primary"
                          shape="round"
                          className="ion-hide-xl-down button__maxwidth"
                        >
                          <span> Stellplatzdaten korrigieren</span>
                        </IonButton>
                      </a>
                    </IonCol>
                  </IonRow>
                </IonCardContent>
              </IonCard>
              {hasNewsData && (
                <IonCard>
                  <IonCardContent>
                    <IonRow>
                      <IonCol size="12">
                        <img src={newsImageUrl} className="card__image" />
                        <h6>Stellplatznews</h6>
                        <h4>{newsName}</h4>
                        <p> {decode(newsExcerpt)}</p>
                      </IonCol>

                      <IonCol size="12" className="ion-text-end">
                        <IonButton
                          color="secondary"
                          shape="round"
                          href={newsLink}
                        >
                          Mehr erfahren
                        </IonButton>
                      </IonCol>
                    </IonRow>
                  </IonCardContent>
                </IonCard>
              )}
            </IonCol>
          </IonRow>
        </IonGrid>
        {hasTourenData && (
          <IonGrid className="content__margin">
            <IonRow>
              <IonCol size="12">
                <IonCard>
                  <IonCardContent>
                    <IonRow>
                      {/*  <IonCol size="12" size-sm="6">
                        <img src={tourenImageUrl} className="card__image" />
                      </IonCol> */}

                      <IonCol
                        className="touren__background__image "
                        size="12"
                        size-md="6"
                        style={{
                          background: `url('${tourenImageUrl}') no-repeat center`,
                        }}
                      ></IonCol>

                      <IonCol
                        size="12"
                        size-md="6"
                        className="ion-padding-start ion-padding-end "
                      >
                        <h6>Wohnmobiltouren und Reiseziele</h6>
                        <h3>Teil der Route: {tourenName}</h3>
                        <p>{decode(tourenExcerpt)}</p>
                        <br />
                        <IonButton
                          color="secondary"
                          shape="round"
                          href={tourenLink}
                        >
                          Mehr erfahren
                        </IonButton>{" "}
                      </IonCol>
                    </IonRow>
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        )}
        {hasSpecialsData && (
          <IonGrid className="content__margin">
            <IonRow>
              <IonCol size="12">
                <IonCard>
                  <IonCardContent>
                    <IonRow>
                      {/*  <IonCol size="12" size-sm="6">
                        <img src={tourenImageUrl} className="card__image" />
                      </IonCol> */}

                      <IonCol
                        className="touren__background__image "
                        size="12"
                        size-md="6"
                        style={{
                          background: `url('${specialsImageUrl}') no-repeat center`,
                        }}
                      ></IonCol>

                      <IonCol
                        size="12"
                        size-md="6"
                        className="ion-padding-start ion-padding-end "
                      >
                        <h6>Specials </h6>
                        <h3>Teil des Specials: {specialsName}</h3>
                        <p>{decode(specialsExcerpt)}</p>
                        <br />
                        <IonButton
                          color="secondary"
                          shape="round"
                          href={specialsLink}
                        >
                          Mehr erfahren
                        </IonButton>{" "}
                      </IonCol>
                    </IonRow>
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        )}
      </IonContent>
    </IonPage>
    
  ) : (
    <></>
  );
}

export default SinglePitch;
